import apiRequest from '@/api/apiRequest';

export async function dictionaryCountriesWithRegions() {
  const res = await apiRequest.get('dictionary/countries?regions=1');

  return res.data.data;
}
